module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_8003.c01befe6.png";